
import { useState, useEffect } from 'react';
import HeroSection from './components/HeroSection';
import AboutLexiSection from './components/AboutLexiSection';
import WhatLexiWantsSection from './components/WhatLexiWantsSection';
import ChallengeSection from './components/ChallengeSection';
import ApplicationForm from './components/ApplicationForm';
import EligibilitySection from './components/EligibilitySection';
import Footer from './components/Footer';

export default function HomePage() {
  const [applicantCount, setApplicantCount] = useState(847);

  useEffect(() => {
    // Simulate live counter updates
    const interval = setInterval(() => {
      setApplicantCount(prev => prev + Math.floor(Math.random() * 3));
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-stone-50 to-stone-100">
      <HeroSection />
      <AboutLexiSection />
      <WhatLexiWantsSection />
      <ChallengeSection applicantCount={applicantCount} />
      <ApplicationForm />
      <EligibilitySection />
      <Footer />
    </div>
  );
}
